import { makeAutoObservable, runInAction } from 'mobx';
import type { RootStore } from './root-store';
// eslint-disable-next-line import/no-cycle
import { PersonalAssetDialogStore } from './personal-asset-dialog-store';
import { PersonalAssetWithValueMobxDto } from '../mobx/dtos/personal-assets/personal-asset-with-value-mobx-dto';
import { PersonalAssetSpecialTypeEnum } from '../../defs/api';
// eslint-disable-next-line import/no-cycle
import { PersonalAssetImportDialogStore } from './personal-asset-import-dialog-store';

export class PersonalAssetStore {
    rootStore: RootStore;

    personalAssetDialogStore: PersonalAssetDialogStore;

    personalAssetImportDialogStore: PersonalAssetImportDialogStore;

    personalAssets: PersonalAssetWithValueMobxDto[] = [];

    limit = Number(process.env.NEXT_PUBLIC_PAGE_LIMIT);

    totalCount = 0;

    page = 1;

    protected sourceType: PersonalAssetSpecialTypeEnum = PersonalAssetSpecialTypeEnum.Monery;

    loading = false;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        this.personalAssetDialogStore = new PersonalAssetDialogStore(this);
        this.personalAssetImportDialogStore = new PersonalAssetImportDialogStore(this);
        makeAutoObservable(this, {
            rootStore: false,
            personalAssetDialogStore: false,
        });
    }

    startLoading(): void {
        this.loading = true;
    }

    stopLoading(): void {
        this.loading = false;
    }

    async fetchPersonalAssetList(
        portfolioId: string,
        sourceType: PersonalAssetSpecialTypeEnum = PersonalAssetSpecialTypeEnum.Monery,
    ): Promise<void> {
        this.startLoading();
        try {
            const [fetchedPersonalAssetList] = await Promise.all([
                this.rootStore.apiClient.personalAssetsApi.personalAssetControllerGetList({
                    portfolioId,
                    sourceType,
                    limit: this.limit,
                    offset: (this.page - 1) * this.limit,
                }),
                this.rootStore.portfolioStore.fetchPortfolioList(),
            ]);

            runInAction(() => {
                this.personalAssets = PersonalAssetWithValueMobxDto.createFromArray(fetchedPersonalAssetList.items);
                this.limit = fetchedPersonalAssetList.limit;
                this.totalCount = fetchedPersonalAssetList.total;
                this.stopLoading();
            });
        } catch (e) {
            runInAction(() => this.stopLoading());
            this.rootStore.alertStore.setErrorMessageByStatus(e.message);
        }
    }

    async setPage(page: number, portfolioId: string): Promise<void> {
        this.page = page;
        await this.fetchPersonalAssetList(portfolioId);
    }

    setPageLimit(limit: number | string | null, portfolioId: string): void {
        if (limit && !Number.isNaN(limit)) {
            this.limit = +limit;
            this.setPage(1, portfolioId);
        }
    }

    get pagesCount(): number {
        return Math.ceil(this.totalCount / this.limit) || 0;
    }
}
